import { createSlice } from "infrastructure/store/lib";
import { getOnboardingsPaymentMethodsThunk } from "features/ecommerce/thunks";
import {
    paymentMethodsRequestFulfilled,
    paymentMethodsRequestLoading,
    paymentMethodsRequestRejected
} from "./reducers";
import initialState, { sliceToken } from "./state";
import { getPaymentMethodsThunk } from "./thunks";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: {
        changePaymentMethodsLoadingState: (state, { payload }) => {
            state.paymentMethodsLoadingState = payload;
        },
        changePaymentMethodsSlice: (state, { payload }) => {
            state.paymentMethodsSlice = payload.data;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(getPaymentMethodsThunk.pending, paymentMethodsRequestLoading)
            .addCase(getPaymentMethodsThunk.fulfilled, paymentMethodsRequestFulfilled)
            .addCase(getPaymentMethodsThunk.rejected, paymentMethodsRequestRejected)
            .addCase(getOnboardingsPaymentMethodsThunk.pending, paymentMethodsRequestLoading)
            .addCase(getOnboardingsPaymentMethodsThunk.fulfilled, paymentMethodsRequestFulfilled)
            .addCase(getOnboardingsPaymentMethodsThunk.rejected, paymentMethodsRequestRejected);
    }
});

export const {
    name,
    actions: {
        changePaymentMethodsLoadingState,
        changePaymentMethodsSlice
    }
} = slice;
export default slice.reducer;
